import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { rowTooltipProps } from './rowTooltip';
import './OriginatingFlowBadge.scss';

interface Props {
  originatingNodeInstanceId: number;
  originatingNodeDefinitionName?: string | null;
  originatingFlowInstanceId?: number | null;
  originatingFlowDefinitionName?: string | null;
  onOpen?: (nodeInstanceId: number) => void;
}

const OriginatingFlowBadge: React.FC<Props> = ({
  originatingNodeInstanceId,
  originatingNodeDefinitionName,
  originatingFlowInstanceId,
  originatingFlowDefinitionName,
  onOpen,
}) => {
  const nodeLabel = originatingNodeDefinitionName ? `${originatingNodeDefinitionName} #${originatingNodeInstanceId}` : `#${originatingNodeInstanceId}`;
  const flowLabel = originatingFlowInstanceId
    ? originatingFlowDefinitionName
      ? `${originatingFlowDefinitionName} (#${originatingFlowInstanceId})`
      : `#${originatingFlowInstanceId}`
    : null;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Plain left-click opens the originating node in the bottom panel. A modifier
    // click (cmd/ctrl/shift/alt) falls through to the href so the browser still
    // opens the instance viewer in a new tab.
    if (onOpen && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      e.preventDefault();
      onOpen(originatingNodeInstanceId);
    }
  };

  return (
    <OverlayTrigger
      placement="top"
      {...rowTooltipProps}
      overlay={
        <Tooltip>
          <div>Originated from {nodeLabel}</div>
          {flowLabel && <div>Flow: {flowLabel}</div>}
          <div>Click to open</div>
        </Tooltip>
      }
    >
      <a
        href={`/instance_viewer/${originatingNodeInstanceId}`}
        target="_blank"
        rel="noopener noreferrer"
        className="originating-flow-badge"
        onClick={handleClick}
      >
        #{originatingNodeInstanceId}
      </a>
    </OverlayTrigger>
  );
};

export default OriginatingFlowBadge;
